var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 30,
    viewBox: "0 0 38 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 6.96429C37.5 8.44353 36.3358 9.64286 34.8999 9.64286C34.8838 9.64286 34.8703 9.63435 34.8542 9.63415L31.5703 28.2435C31.3898 29.2567 30.5317 30 29.5242 30H8.03432C7.02938 30 6.16745 29.2594 5.98804 28.2408L2.70476 9.63616C2.68851 9.63616 2.67486 9.64286 2.6001 9.64286C1.1642 9.64286 0 8.44353 0 6.96429C0 5.48504 1.2227 4.28571 2.6001 4.28571C3.97751 4.28571 5.20021 5.48504 5.20021 6.96429C5.20021 7.56683 4.97133 8.09531 4.64528 8.54263L10.4715 13.344C11.5057 14.1964 13.0391 13.8492 13.6312 12.6288L17.3754 4.91451C16.6407 4.44241 16.1206 3.63884 16.1206 2.67857C16.1206 1.19933 17.3427 0 18.7792 0C20.2158 0 21.3209 1.19933 21.3209 2.67857C21.3209 3.63884 20.8032 4.44241 20.0663 4.91518L23.8105 12.6295C24.4027 13.8496 25.9367 14.1964 26.9702 13.3446L32.7964 8.5433C32.5273 8.09598 32.2998 7.5067 32.2998 6.96429C32.2998 5.48437 33.4633 4.28571 34.8999 4.28571C36.3365 4.28571 37.5 5.48437 37.5 6.96429Z",
    fill: "url(#paint0_linear_10_746)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10_746",
    x1: 18.75,
    y1: 0,
    x2: 18.75,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF3616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE7734"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.cea0e43bfe900aad8c879179cd5e5f97.svg";
export { ForwardRef as ReactComponent };